import { Link } from '@tanstack/react-router'
import { PanelLeftClose, PanelLeftOpen } from 'lucide-react'
import { useSession } from '@shared/lib/auth/session-store'
import { useAdminRuntimeCapabilities } from '@features/admin/api/admin.api'
import { canAccessNavItem, navItemCapabilityMet, navItems } from './nav-items'
import { collapseButton, nav, navItem, navLabel, sidebar } from './AppShell.css'

type SidebarProps = {
  collapsed: boolean
  onCollapsedChange: (next: boolean) => void
}

export function Sidebar({ collapsed, onCollapsedChange }: SidebarProps) {
  const ToggleIcon = collapsed ? PanelLeftOpen : PanelLeftClose
  const user = useSession((state) => state.user)
  const capabilities = useAdminRuntimeCapabilities()
  const visibleItems = navItems.filter(
    (item) => canAccessNavItem(item, user) && navItemCapabilityMet(item, capabilities.data),
  )

  return (
    <aside className={sidebar} data-collapsed={collapsed ? 'true' : 'false'} data-testid="sidebar">
      <nav className={nav}>
        {visibleItems.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={navItem}
            title={collapsed ? item.label : undefined}
            aria-label={collapsed ? item.label : undefined}
          >
            <item.icon size={18} />
            {collapsed ? null : <span className={navLabel}>{item.label}</span>}
          </Link>
        ))}
      </nav>
      <button
        type="button"
        className={collapseButton}
        aria-label={collapsed ? 'Expandir menu' : 'Recolher menu'}
        aria-expanded={!collapsed}
        title={collapsed ? 'Expandir menu' : undefined}
        onClick={() => onCollapsedChange(!collapsed)}
      >
        <ToggleIcon size={18} />
        {collapsed ? null : <span className={navLabel}>Recolher</span>}
      </button>
    </aside>
  )
}
